<div class="container">
    <section class="inner-container">
    <main>
        <section data-parallax="full" class="product-detail-banner" style="background-image: url(images/submit-bg.jpg)">
            <div class="caption center-full">
                <div class="inner">
                <h2>E-mail Verified.</h2>
                <p class="point">
                    Your e-mail address has been verified.<br>
                    Please click the link below to login.
                </p><br>
                <div class="row text-center">
                    <!-- <div class="col-md-6">
                        <button class="btn btn-primary" (click)="home()"> BACK TO HOMEPAGE </button>
                    </div> -->

                    <div class="col-md-6 col-md-offset-3">
                        <button class="btn btn-primary" (click)="login()"> LOG IN </button>  
                    </div>
                </div>
                                
                </div>
            </div>
        </section>
    </main>
    </section>
</div>
